<div class="ft2-profile-image"
     [class.-small]="size === 'small'"
     [ftBackgroundImage]="user.profileImageUrl">
    <span class="ft2-profile-image_initials" *ngIf="!user.profileImageUrl">
        {{[user.firstName, user.lastName] | initialLetters | joinWith : ""}}
    </span>
</div>
